import {createSlice} from "@reduxjs/toolkit";

interface State {
    paymentEnabled: boolean
}

const initialState: State = {
    paymentEnabled: false,
}

const paymentSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: {
        enable(state) {
            state.paymentEnabled = true
        },
        disable(state) {
            state.paymentEnabled = false
        }
    }
})

export const paymentActions = paymentSlice.actions
export const paymentReducer = paymentSlice.reducer
